<template>
    <div class="field">
        <label for="category">Category</label>
        <TreeSelect v-model="selectedCategory" :options="allCategories" selectionMode="single" placeholder="Select a category type" class="w-full" @change="updateCategory" />
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { categoryStore } from '../../../../../store/global-stores';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Number,
    },
});
// category store properties
const { allCategories } = storeToRefs(categoryStore);

const selectedCategory = ref(null);

onMounted(() => {
    // load all categories
    loadCategories();
    // load selected category, if exists
    loadSelectedCategory();
});

const loadCategories = async () => {
    await categoryStore.fetchCategories();
};

const loadSelectedCategory = () => {
    if (props.modelValue) {
        selectedCategory.value = { [props.modelValue]: true };
    }
};

const updateCategory = () => {
    // debugger;
    if (selectedCategory.value) {
        const key = Object.keys(selectedCategory.value)[0];
        emit('update:modelValue', parseInt(key));
    }
};
</script>
